export type DeviceBreakPoint =
  | 'mobile'
  | 'mobileLandscape'
  | 'tablet'
  | 'tabletLandscape'
  | 'desktop'
  | 'desktopLarge'
  | 'desktopWide';

export const breakpoints: DeviceBreakPoints = {
  mobile: 320,
  mobileLandscape: 480,
  tablet: 768,
  tabletLandscape: 1024,
  desktop: 1200,
  desktopLarge: 1500,
  desktopWide: 1920
};

export type DeviceBreakPoints = Record<DeviceBreakPoint, number>;

// Props for the app's `ReactBreakpoints` provider. `snapMode` is what makes the
// provider hand `currentBreakpoint` to `withBreakpoints` consumers — without it
// the context carries only `screenWidth`, which nothing here reads, and every
// `currentBreakpoint` check (teaser row sizes, the back-to-top button, the
// product teaser's mobile layout) silently fell back to its desktop branch.
export const breakpointProviderProps = {
  breakpoints,
  snapMode: true
};
